import { render, staticRenderFns } from "./PickingSegnalazioni.vue?vue&type=template&id=701d3e12&"
import script from "./PickingSegnalazioni.vue?vue&type=script&lang=js&"
export * from "./PickingSegnalazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports